import {
    BALANCE_ISSUE,
    EXTERNAL,
    MAX_AMOUNT_BONUS_ISSUE,
    MAX_AMOUNT_BONUS_LIMIT_ISSUE,
    MAX_AMOUNT_ISSUE,
    MIN_AMOUNT_ISSUE,
    MULTIPLE_AMOUNT_ISSUE,
    PAYMENT_BANK_CARD,
    PAYMENT_IDEAL,
    PAYMENT_INTERAC,
    PAYMENT_PEOPLE_TRUST_INTERAC,
} from 'apps/auth/constants/Constants';
import { CVV, FROM_ACCOUNT, PAYMENT_METHOD, SOURCE, SOURCE_CARD_EXP_DATE, SOURCE_CODE_FROM } from 'apps/auth/constants/fieldsName';
import { AUTH_SEND_CHANGE_PAYMENT_METHOD } from 'apps/auth/constants/UrlConstants';
import { getLocalizedRawAmount } from 'apps/auth/helpers/formats';
import { getExtra, resolveArguments, toLowerCase } from 'apps/auth/helpers/utils';

export const getText = (props, amountIssue, restriction, methodMaxInfo, methodMinInfo, balanceNotEnough, bonusAmount, lang, country) => {
    const ccyIso = restriction?.ccyIso;
    const minAmount = restriction?.minAmount;
    const maxAmount = restriction?.maxAmount;
    if (amountIssue === MAX_AMOUNT_ISSUE) {
        return resolveArguments(methodMaxInfo, [`${getLocalizedRawAmount(lang, country, maxAmount)} ${ccyIso}`, props.name]);
    } else if (amountIssue === MIN_AMOUNT_ISSUE) {
        return resolveArguments(methodMinInfo, [`${getLocalizedRawAmount(lang, country, minAmount)} ${ccyIso}`, props.name]);
    } else if (amountIssue === BALANCE_ISSUE) {
        const delta = props.amountFrom - bonusAmount;
        return resolveArguments(balanceNotEnough, [`${getLocalizedRawAmount(lang, country, delta)} ${ccyIso}`, props.name]);
    }
};

const getAmountForChange = (props, amountIssue, restriction, bonusAmount) => {
    const minAmount = restriction.minAmount;
    const maxAmount = restriction.maxAmount;
    if (amountIssue === MAX_AMOUNT_ISSUE || amountIssue === MAX_AMOUNT_BONUS_ISSUE || amountIssue === MAX_AMOUNT_BONUS_LIMIT_ISSUE) {
        return maxAmount;
    } else if (amountIssue === MIN_AMOUNT_ISSUE) {
        return minAmount;
    } else if (amountIssue === BALANCE_ISSUE) {
        return bonusAmount;
    }
};

export class GTPaymentMethodService {
    #updateFieldValues;
    #updateFormProperties;
    #formName;
    #toCountryCode;
    #toCurrencyCode;
    #deliveryMethod;
    #typeOfTransfer;
    #isIncomplete = false;

    #isGlobalFlow = false;

    constructor(updateFieldValues, updateFormProperties, formName, toCountryCode, toCurrencyCode, deliveryMethod, typeOfTransfer, incomplete) {
        this.#updateFieldValues = updateFieldValues;
        this.#updateFormProperties = updateFormProperties;
        this.#formName = formName;
        this.#toCountryCode = toCountryCode;
        this.#toCurrencyCode = toCurrencyCode;
        this.#deliveryMethod = deliveryMethod;
        this.#typeOfTransfer = typeOfTransfer || 'all';
        this.#isIncomplete = incomplete || false;
    }

    static getIssueType(value, min, max, multiple, bonusBalance) {
        let issueType;
        const fValue = parseFloat(value);
        const fBonusBalance = !!bonusBalance ? parseFloat(bonusBalance.replace(' ', '')) : undefined;
        const fMultiple = !!multiple ? parseFloat(multiple) : undefined;
        const fMin = parseFloat(min);
        const fmMax = parseFloat(max);

        if (fBonusBalance && fValue > fBonusBalance) {
            issueType = BALANCE_ISSUE;
        } else if (fValue < fMin && fValue) {
            issueType = MIN_AMOUNT_ISSUE;
        } else if (fmMax && fValue > fmMax) {
            issueType = MAX_AMOUNT_ISSUE;
        } else if (fMultiple && fValue % fMultiple !== 0) {
            issueType = MULTIPLE_AMOUNT_ISSUE;
        }

        return issueType;
    }

    static getPopupTitle(props, methodMaxInfo, methodMinInfo, balanceNotEnough, bonusAmount, lang, country) {
        if (props.fromAmountIssue) {
            return getText(
                props,
                props.fromAmountIssue,
                props.commission.restrictionFrom,
                methodMaxInfo,
                methodMinInfo,
                balanceNotEnough,
                bonusAmount,
                lang,
                country,
            );
        } else if (props.toAmountIssue) {
            return getText(
                props,
                props.toAmountIssue,
                props.commission.restrictionTo,
                methodMaxInfo,
                methodMinInfo,
                balanceNotEnough,
                bonusAmount,
                lang,
                country,
            );
        }
    }

    static getAmount = (props, bonusAmount) => {
        if (props.fromAmountIssue) {
            return getAmountForChange(props, props.fromAmountIssue, props.commission.restrictionFrom, bonusAmount);
        } else if (props.toAmountIssue) {
            return getAmountForChange(props, props.toAmountIssue, props.commission.restrictionTo, bonusAmount);
        }
    };

    setIsGlobalFlow() {
        this.#isGlobalFlow = true;
    }

    changePaymentMethod(method, code, callback) {
        const fields = {
            [PAYMENT_METHOD]: method,
            [SOURCE_CODE_FROM]: code,
            [SOURCE]: code,
        };
        if (method === PAYMENT_BANK_CARD) {
            fields[CVV] = null;
            if (code === undefined || getExtra(code, 'type') === EXTERNAL) {
                fields[SOURCE_CARD_EXP_DATE] = null;
                fields[FROM_ACCOUNT] = null;
            }
        }

        // при смене карты на интерас или идеал остается номер карты в значении фром аккаунт
        if (method === PAYMENT_IDEAL || method === PAYMENT_INTERAC || method === PAYMENT_PEOPLE_TRUST_INTERAC) {
            fields[FROM_ACCOUNT] = null;
        }

        let link = `${AUTH_SEND_CHANGE_PAYMENT_METHOD}${toLowerCase(this.#toCountryCode)}/${toLowerCase(this.#toCurrencyCode)}/${this.#deliveryMethod}?type=${this.#typeOfTransfer}&isIncomplete=${this.#isIncomplete}`;

        this.#updateFieldValues(this.#formName, fields).then(() => {
            this.#updateFormProperties(this.#formName, link, false).then(() => {
                if (callback) {
                    callback();
                }
            });
        });
    }
}
